export default {
  common: {
    label_fr:"francais",
    label_en:"english",
    label_es:"spanish",
    labelActions55:"Actions 5•5",
    labelCollections55:"Collections 5•5",
    labelClassics:"Classics",
    labelCreateYourModel: "Create my model",
    labelPreviousProject: "Previous project",
    labelNextProject:"Next project",
    footerLegals:"Legal notice",
    footerOberSurfacesBrand:"A brand of Ober Surfaces",
    footerPageOnTop:"Back to top",
    LabelOpenProject:"See the project",
    realisationsBackbutton:"Back to the applications",
    labelArchitect:"Architect",
    labelDesign:"Design",
    labelPattern:"Pattern",
    labelSurface:"Surface",
    cancelButton: "Cancel",
    submitButton: "Submit",
    createButton: "Create",
    saveButton: "Save",
    deleteButton: "Delete",
    continueButton: "Continue",
    newFolder: "New folder"



  },
  layout: {
    myaccount: "My account",
    mymodels: "My models"
  },
  menu: {
    menuCreate:"Create a model",
    menuAbout:"About",
    menuCollections:"Collections",
    menuRealisations:"Applications",
    menuContact:"Contact",
    menuSupport:"F.A.Q"
  },
  header: {
  },
  footer: {
    newProjectLabel: "New folder"
  },
  realisations: {
    internationalInstitution:"International Institution",
    ministryOfForeignAffairs:"Ministry of Foreign Affairs"
  },
  collections: {
    titleSurfaces: "The Surfaces",
    titlePatterns: "The Patterns",
  },
  collectionsList: {
    titleSurfaces: "The Surfaces",
    titlePatterns: "The Patterns",
    pageintroduction1: "Discover all the collections",
    pageintroduction2: "on our websites",
    oberflexDescription: "The elegance of solid wood combined with the high resistance of Oberflex surfaces: exceptional technology for the most selective projects.",
    marotteDescription: "Dyed wood veneers that bring out the intense colors and fine grain of wood.",
    purepaperColorDescription: "A collection of decorative surfaces that features 25 handpicked, extra matte and deep colors similar to that of blotting paper.",
    purepaperMetalDescription: "Copper, stainless steel, brass, aluminum or gunmetal colors are part of a palette of 11 metal surfaces featuring a brushed, shiny or mill finish."
  },
  patternsList: {
    titleSurfaces: "The Surfaces",
    titlePatterns: "The Patterns",

    action55Description: "The new collection of customizable acoustic panels. Comprises 6 models that can be configured into an infinite number of perforated patterns.",
    collections55Description: "Five collections designed by Studio 5•5 Each collection features five patterns: an architectural skin, a space garment, a living wall, a vibrating panel or a landscape.",
    classicsDescription: "The basics for a discreet look. The panels feature round, oblong or invisible perforations made using the micro-perforation technology.",
    discoverbutton:"Discover the range",
  },
  about: {
    pageDescription1:"Obersound is a concept of acoustic panels designed and developed",
    pageDescription2:"by Studio 5•5 collective for Ober Surfaces,",
    pageDescription3:"a manufacturer of decorative and technical interior design solutions.",
    obersurfacesDescription1:"Driven by values of innovation and eco-design, Ober-Surfaces offers a wide selection of decorative surfaces for interiors through the brands Oberflex, Marotte, Pure Paper and Staron. The company is always attentive to reacting closely to design evolution, constantly anticipating inquiry for novelties and does everything to satisfy the requirements of creation.",
    obersurfacesDescription2:"This creative energy is also behind Ober Surfaces decision to work with outside partners and to create collections in collaboration with architects and designers. The company is currently working with Studio 5•5 to explore new acoustic perforation solutions.",
    obersurfacesDescription3:"All our aesthetic, technical and acoustic solutions can be found on ober-surfaces.com",
    studio55Description1:"5•5 is a design collective co-founded in August 2003 by Vincent Baranger, Jean-Sébastien Blanc, Anthony Lebossé, and Claire Renard after they graduated from the Ecole Nationale Supérieure des Arts Appliqués.",
    studio55Description2:"Though the small collective has grown into a studio, the spirit has remained the same. Having championed cheerful collaboration between individuals since the very beginning, 5•5 Studio brings together multidisciplinary creative talents around a generalist design approach. Today, Studio 5•5 run a business capable of catering to their clients' needs with the same principles as when they started: always remain close to people by designing useful and aspirational products for the greatest number with a view to brightening up our everyday life",
  },

  support: {
    titleTechnicalQuestion:"Technical questions",
    titleBusinessQuestion:"Sales questions",
    titleAcousticQuestion:"Acoustic questions"
  },
  supportTechnical: {
    question1:"What are Obersound panels designed to do?",
    boldWords1:"Obersound panels",
    answer1:"Obersound panels are designed to improve the acoustic comfort of indoor spaces. When mounted on walls and ceilings, they absorb part of the sound wave, limiting reverberation.",

    question2:"What does an Obersound panel consist of?",
    boldWords2:"Obersound panel",
    answer2:"An Obersound panel consists of an MDF core (substrate panel) clad with a decorative surface in colored wood or metal, and a backing board. Once perforated, the back of the Obersound panel is lined with black felt.",

    question3:"What size do Obersound panels come in?",
    boldWords3:"size",
    answer3:"Obersound panels come in standard size: 2500x1200 mm or 3000x1200 mm. They can also be custom-built according to a plan and a cutting list provided by you.",

    question4:"How are the edges of Obersound panels treated?",
    boldWords4:"edges of Obersound panels",
    answer4:"The edges (sides) of Obersound panels can be left untreated (black MDF) or lined with a surface layer that matches the face of the panel.",

    question5:"How do I install Obersound panels?",
    boldWords5:"install",
    answer5:"Obersound panels are installed in the same way as traditional panels. A joiner or a qualified installer will use a fastening system suitable for the space (keys, profiles, etc.). The backs of the panels are to be covered with a layer of rock wool for optimal acoustic absorption.",

    question6:"Can I use the model I configured as a ceiling?",
    boldWords6:"ceiling",
    answer6:"Obersound acoustic panels can be used as walls or ceilings. Ober Surfaces' customer service department can recommend the most suitable sizes and installation methods based on technical constraints specific to each project.",

    question7:"Can I combine my acoustic panels with panels made with the same veneer but without perforation?",
    boldWords7:"acoustic panels",
    boldWords7_1:"without perforation",
    answer7:"Unperforated panels are indispensable in any acoustic layout (doors, door frames, baseboards, plate rail moldings…) and are available in all the surfaces featured in the Obersound configurator. To ensure uniformity between the panels, we recommend ordering all of them at the same time.",

    question8:"Who do I need to contact for an acoustics study for my project?",
    boldWords8:"acoustics study",
    answer8:"The architect, who often works with an acoustician, is the person who provides acoustics recommendations for the project.",

    question9:"Standard size panels are not suitable for my projects because I will be left with too many cut-offs. What are my options?",
    boldWords9:"Standard size panels",
    answer9:"Throughout the design process of your project, Ober Surfaces' customer service department can look at your plans and suggest suitable solutions such as custom-made panels, adjustments to your layout, etc.",

  },
  supportBusiness: {
    question1:"How do I find out the price of a model I configured?",
    boldWords1:"price",
    answer1:"Ober Surfaces' customer service department will provide your joiner with a price quote for the model of configured panel. The price per square meter of Obersound panels varies mainly according to the type of decorative surface and perforation.",

    question2:"How long does it take to make Obersound panels?",
    boldWords2:"How long",
    answer2:"Each Obersound panel is unique and is especially made according to the options recommended by the configurator. The standard lead time is 4 to 5 weeks, except in particular cases.",

    question3:"I am a joiner or an installer. What type of information do I need to provide to get a quote?",
    boldWords3:"type of information",
    answer3:"Ober Surfaces' customer service department prepares a price quote based on the technical data sheet of the configured product, the dimensions and desired quantities and may suggest additional options such as edge machining, fire-resistance rating, mounting profiles, etc.",

    question4:"Can I combine my acoustic panels with panels made with the same veneer but without perforation?",
    boldWords4:"acoustic panels",
    boldWords4_1:"without perforation",
    answer4:"Unperforated panels are indispensable in any acoustic layout (doors, door frames, baseboards, plate rail moldings…) and are available in all the surfaces featured in the Obersound configurator. To ensure uniformity between the panels, we recommend ordering all of them at the same time.",

    question5:"Who do I need to contact for an acoustics study for my project?",
    boldWords5:"acoustics study",
    answer5:"The architect, who often works with an acoustician, is the person who provides acoustics recommendations for the project.",

    question6:"I need to give my client a prototype of the configured model. Is it possible to get one?",
    boldWords6:"prototype of the configured model",
    answer6:"Yes. Simply contact Ober Surfaces' customer service department to get an estimate of the cost of making the prototype.",

    question7:"Can I request a sample of the surface I want for the panel I configured?",
    boldWords7:"sample",
    answer7:"Yes. Simply contact Ober Surfaces' customer service department to request a sample.",

    question8:"Standard size panels are not suitable for my projects because I will be left with too many cut-offs. What are my options?",
    boldWords8:"Standard size panels",
    answer8:"Throughout the design process of your project, Ober Surfaces' customer service department can look at your plans and suggest suitable solutions such as custom-made panels, adjustments to your layout, etc."
    },
  supportAcoustic: {
    question1:"How do I interpret the acoustic data available on the Obersound configurator?",
    boldWords1:"acoustic data",
    answer1:"Good management of a space's acoustics does not necessarily require maximum absorption. The graph illustrates the level of absorption based on frequencies.",

    question2:"Should I always choose the most sound-absorbing models?",
    boldWords2:"most sound-absorbing",
    answer2:"Evaluating the most suitable level of absorption for a given space is based on several criteria like the purpose of the space (Lobby, restaurant, offices…), its configuration or the existence of other sound-absorbing materials and elements (rugs, fabric, furniture, etc.)",

    question3:"Who do I need to contact for an acoustics study for my project?",
    boldWords3:"an acoustics study",
    answer3:"The architect, who often works with an acoustician, is the person who provides acoustics recommendations for the project."
    },
  home: {
    page2Action55Description: "The new collection of customizable acoustic panels.",

    page3Description: "Comprises 6 models that can be configured into an infinite number of perforated patterns",

    page4Description: "A new tool for exploring all the Obersound acoustic solutions that can be combined with Ober Surfaces® collections",

    page4Step1Title:"Create your models using the configurator",
    page4Step1Description:"Select your patterns and mix and match them with over 160 different surfaces",
    page4Step2Title:"Create your Materials library",
    page4Step2Description:"File your creations in a personal library.",
    page4Step3Title:"Download your models and data sheets",
    page4Step3Description:"Download the HD images and technical information",

    page5Title:"Start experimenting with all the Obersound solutions",
    page5Pattern1Description:"The new collection of customizable acoustic panels comprises 6 models that can be configured into an infinite number of perforated patterns",
    page5Pattern2Description:"Five collections designed by Studio 5•5. Each collection features five patterns: an architectural skin, a space garment, a living wall, a vibrating panel or a landscape.",
    page5Pattern3Description:"The basics for a discreet look. The panels feature round, oblong or invisible perforations made using the micro-perforation technology.",
  },
  terms: {
    titleTerms:"Legal and Privacy Notice",
    textTerms:"By entering, using and logging in to this website, you acknowledge and agree, without reservation, to its terms of use.",
    title1:"1. Company Information",
    text1_1:"The website that you are currently using www.obersound.com is the property of:",
    text1_2:"OBER&lt;br/&gt;31 rue de Bar, 55000 Longeville en Barrois&lt;br/&gt;France&lt;br/&gt;T : +33 3 29 76 77 78&lt;br/&gt;obercom@ober-surfaces.com&lt;br/&gt;&lt;br/&gt;a public limited company Company with a share capital of 2 061 509 €&lt;br/&gt;organized under the form of a Société Anonyme (SA) and registered with the Trade€&lt;br/&gt;Registry of Bar le Duc under number B 382 745 404&lt;br/&gt;Intra-EU VAT Identification Number: FR 82 382 745 404&lt;br/&gt;",
    text1_3:"Director of publications: Etienne de la Thébeaudière &lt;br/&gt;This website is hosted by Firebase, 188 King ST, San Francisco, CA 94107, United States, https ://firebase.google.com/. &lt;br/&gt;This website was designed by the 5&#8226;5 Studio, 8 rue Popincourt 75011 PARIS, France&lt;br/&gt;This site was developed by Sensology, 21 rue Trévise 75009 PARIS, France&lt;br/&gt;",
    title2:"2. Personal Information",
    text2_1:"We collect your personal information when you sign up on our site or when you log into your account.",
    text2_2:"We may use the information we collect from you to:&lt;br/&gt;- Allow us to address your needs as part of the business relationship between you and Ober&lt;br/&gt;- Help us improve our website&lt;br/&gt;- Contact you by email or by telephone&lt;br/&gt;- Send you our newsletters",
    text2_3:"Pursuant to the EU General Data Protection Regulation (GDPR) of the European Parliament and the European Council for Data Protection Number 2016/679 dated April 26, 2016, you may access, update, modify or delete your personal information at any time. Please email us at obercom@ober-surfaces.com",
    text2_4:"Ober hereby expressly undertakes not to divulge your information to third parties.",
    title3:"3. Cookies",
    text3_1:"Cookies are small text files that are placed on your computer or your peripheral device when you visit our website to make your visits more efficient. They also help us to improve navigation.",
    text3_2:"We use cookies to:&lt;br/&gt;- Memorize your log in information&lt;br/&gt;- Identify you when you log in to our website&lt;br/&gt;- Collect analytical data in order, for instance, to count the number of visitors to our website and keep track of the pages that are most frequently visited.",
    title4:"4. Intellectual Property",
    text4_1:"Access to www.obersound.com gives you the right to private and non exclusive use of this website.",
    text4_2:"All texts, photographs and any other documents published on this website are the property of Ober or are used under the authorization of their owners and are subject to copyright and intellectual property rights. Any reproduction and/or total or partial representation of the contents of this website without the express prior authorization of Ober is prohibited.",
    text4_3:"Fraudulent use of any content on the website www.obersound.com is strictly prohibited. Ober will fully exercise its intellectual property rights to pursue legal proceedings, including filing criminal lawsuits, if necessary.",
    title5:"5. Terms of Use",
    text5_1:"Ober makes every effort to ensure the accuracy of all information published on this website and to constantly update such information. Ober reserves the right to amend or modify the content of this website at any time and without prior notice.",
    text5_2:"The information contained on this website (Technical specifications sheets, illustrations, images or any other items) is not binding.",
    text5_3:"Ober undertakes to make its best effort to make the website available to users at any time. Ober shall not be held liable should the website become temporarily or wholly unavailable for any reason whatsoever.",
    title6:"6. Limitation of liability",
    text6_1:"Using and navigating this website is your sole and exclusive responsibility. Neither Ober nor third parties involved in the design, production or operation of this website shall be held liable for direct, indirect, incidental, consequential or other damages resulting from your access to or use of this website, including, without limitation, loss of operation, loss of data or disruption of services.",
    text6_2:"Likewise, Ober shall not be held liable for damages or viruses that may infect your computer or any other device, nor shall it be held liable for data loss or alteration resulting from your access to this website or downloads made from this website. In no event shall Ober&#39;s total liability, on any grounds whatsoever, exceed the amount paid by you for accessing this website.",
    text6_3:"Ober undertakes to make its best effort to make the website available to users at any time. Ober shall not be held liable should the website become temporarily or wholly unavailable for any reason whatsoever.",
    title7:"7. Contact",
    text7_1:"You may contact us by email at obercom@ober-surfaces.com"

    //   &lt;br/&gt;
  },
    contact: {
      contactTitle: "Contact us",
      firstname:"First name*",
      name:"Last name*",
      company:"Company*",
      activity:"Business sector*",
      address:"Address*",
      postCode:"Post code*",
      city:"City*",
      country:"Country*",
      phoneNumber:"Phone number*",
      job:"Title*",
      emailAdress:"E-mail*",
      subjectMessage:"Object of your message*",
      yourMessage:"Your message*",
      sendButton:"Send",
      fieldsRequired:"* Required information",
      messageSending:"Sending e-mail",
      messageSent:"Your message has been sent.",
      mapLanguage:"en",
      headOffice:"Head office"

    },
    signup:{
      civility:"wazzaa",
      aaqa:"",
      aasa:""
    },
    signin:{
      connect:"Log in",
      introPage:"You need to log in to your account<br />to <span class='font-bold'>save</span> and <span class='font-bold'>download</span> your models.",
      noaccount:"Don't have an account yet?",
      identify:"Identification",
      connectButton:"Connect",
      inscriptionButton:"Register",
      emailAdressTextfield:"Email address",
      passwordTextfield:"Password",
      forgottenPassword:"Forgot your password?"
    },
    userActivities:{
        activity0title: "Business sector", // (not used anymore) Marques localisation => i18n
        activity1title: "Architect",
        activity2title: "Interior designer",
        activity3title: "Designer",
        activity4title: "Technical Department",
        activity5title: "General contractor",
        activity6title: "Developer",
        activity7title: "Woodworker / Shopfitter",
        activity8title: "Estimator",
        activity9title: "Acoustic consultant",
        activity10title: "Industrial operators",
        activity11title: "Building owner",
        activity12title: "Other"
    },
    modals:{
      modifyMyFolder:"Modify my folder",
      deleteFolderConfirmation:"Are you sure you want to delete this folder?",
      deleteModelConfirmation: "Are you sure you want to delete this model?",
      deleteAccountConfirmation: "Are you sure you want to delete your account?",
      shareModelTitle:"Share your model",
      shareModelText:"Share your model's URL page:",
      shareModelCopyText:"Copy",
      shareModelCopiedText:"Copied",
      downloadModalTitle:"Download",
      downloadModalHDfile:"HD images",
      downloadModalExportButton:"Export",
      downloadModalProductPerforatedSurface:"Perforated surface",
      downloadModalProductNonPerforatedSurface:"Non-perforated surface",
      downloadModalProductPageButton:"Product Page",
      downloadModalGenerateButton:"Générate",
      downloadModalDownloadButton:"Download",

      acousticPerformanceTitle:"Acoustic performance",

      welcomeModelTitle: "Welcome to « My models » page!",
      welcomeModelText1: "You can save and upload your models from this page. You can organize, modify or delete your creations at any time.",
      welcomeModelText2: "Click on the « My models » button located to the right of your navigation bar to access this page.",

      addToExistingFolder:"Add to an existing folder",
      createNewFolder:"Create a file to save my model",
      exArchitectForm:"Example: Various architect"

    },
    account:{
      inscriptionPageTitle:"Register",
      civilitySign:"Gender*:",
      civilityMrSign:"Mr",
      civilityMrsSign:"Mrs",
      lastNameSign:"Last name*",
      firstNameSign:"First name*",
      companyNameSign:"Company*",
      addressSign:"Address*",
      citySign:"City*",
      postCodeSign:"Post Code*",
      countrySign:"Country*",
      emailAddressSign:"Your email*",
      emailAddressConfirmSign:"Confirm your email*",
      passwordSign:"Your password*",
      passwordConfirmSign:"Confirm your password*",
      requiredSign:"* Required information",
      //my account
      disconnect:"Log out",
      deleteAccount:"Delete my account",
      newPasswordSign:"New password",
      newPasswordConfirmSign:"New password confirmation",
      emptyLabel:"If the password field is left blank, the password is not changed.",

    },
    pdf:{
          pdfLoading:"Loading...",
          pdfLogoTitle:" Acoustic solutions",
          pdfProductSpec:"Product datasheet",
          pdfProductRef:"Reference :",
          pdfLabelName:"Last name :",
          pdfLabelCompany:"Company :",
          pdfLabelFolderName:"Name of the file :",
          pdfLabelDate:"Date :",
          pdfLabelDescription:"Description",
          pdfLabelMaker:"Manufacturer :",
          pdfLabelSurface:"Surface :",
          pdfLabelAcousticPerformance:"Acoustic perforation",
          pdfLabelSupport:"Substrate :",
          pdfLabelSupportMDF16:"Natural MDF 16 mm",
          pdfLabelContreface:"Counterface :",
          pdfLabelContrefaceVoileNoir:"Black felt",
          pdfLabelSize:"Dimensions :",
          pdfLabelSizeContent:"standard 2490 x 1220 mm or customized",
          pdfLabelThickness:"Total thickness :",
          pdfLabelFireClassification:"Fire rating :",
          pdfLabelSurfaceResistance:"Surface resistance :",
          pdfLabelSurfaceResistanceNorme:"in accordance with the EN-438 standard",
          pdfLabelRegisteredDesign: "Obersound pattented model",
          pdfLabelCustomSizes: "Custom dimensions according to the plans and cutting list.",
          pdfLabelNB : "Non perforated surfaces available on request.",
          pdfLabelAcouticPerf: "Acoustic performance",
          pdfLabelAcouticPerfAw: "\u03b1w :",
          pdfLabelPerforationRate: "Perforation rate :",
          pdfLabelAvailableSoon: "Acoustic performance soon available",
          pdfLabelMakerContact: "Contact the manufacturer",
          pdfLabelTechnicalSupport: "Technical support :",
        },
    editor:{
        introCreatePage:"Select a surface or a pattern to start.",

        leftPanelSurfacesTitle:"Surfaces",
        RightPanelPatternsTitle:"Patterns",

        SurfacesFilter:"Filter my search",
        SurfacesChange:"Change my search",
        noSearchResult:"Sorry, there is no result for your request",
        diameterLabel:"Diameter",
        entraxeLabel:"Center distance",

        brandIdFilter:"Brands:",
        brandIdFilterTitle1:"Oberflex",
        brandIdFilterTitle2:"Marotte",
        brandIdFilterTitle3:"Pure Paper Color",
        brandIdFilterTitle4:"Pure Paper Métal",

        typeIdFilter:"Types:",
        typeIdFilterTitle2:"Wood veneer laminates",
        typeIdFilterTitle3:"Varnished woods",
        typeIdFilterTitle1:"Colors",
        typeIdFilterTitle4:"Metal",

        shadeIdFilter:"Shades:",
        shadeIdFilterTitle1:"Light",
        shadeIdFilterTitle2:"Medium",
        shadeIdFilterTitle3:"Dark",

        collectionIdFilter:"Collections:",
        collectionIdFilterTitle1:"Actions 5•5",
        collectionIdFilterTitle2:"Collections 5•5",
        collectionIdFilterTitle0:"Classics",

        absorptionIdFilter:"Acoustical absorption:",
        absorptionIdFilterTitle1:"Medium",
        absorptionIdFilterTitle1Subtitle:"(aw 0,1 to 0,5)",
        absorptionIdFilterTitle2:"High",
        absorptionIdFilterTitle2Subtitle:"(aw 0,5 to 0,75)",
        absorptionIdFilterTitle3:"High +",
        absorptionIdFilterTitle3Subtitle:"(aw 0,75 to 0,95)",

        acousticPerformanceButton:"Acoustic performance",
        acousticPerformanceLabel:"Acoustic performance:",
        PerforationRateLabel:"Perforation rate:",
        acousticPerformanceComingSoon:"Acoustic performance soon available",


        validateButton:"Confirm",
        validationMessage:"Your model has been saved."
    }
};



// WEBPACK FOOTER //
// ./src/i18n/en.js